import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-09-24
	search(params) {
		return axios.get('/weddingDressHall/rent-package?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-10-20
	findByTenantId() {
		return axios.get('/weddingDressHall/rent-package/find-by-tenant-id');
	},
	// 2021-09-26
	findByName(params) {
		return axios.get('/weddingDressHall/rent-package/find-by-name', params);
	},
	// 2021-09-26
	create(params) {
		return axios.post('/weddingDressHall/rent-package', params);
	},
	// 2021-09-26
	delete(id) {
		return axios.delete('/weddingDressHall/rent-package/' + id)
	},
	// 2021-09-26
	update(id, params) {
		return axios.put('/weddingDressHall/rent-package/' + id, params);
	},
	// 2021-09-26
	copy(id, params) {
		return axios.put('/weddingDressHall/rent-package/' + id + '/copy', params)
	},
	// 2021-09-27
	findWorkbench() {
		return axios.get('/weddingDressHall/rent-package/find-workbench')
	},
	// 	// 2021-03-22
	// 	exportExcel(params) {
	// 		return axios.get('/weddingDressHall/rent-package/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// 	},
	// 2021-09-26
	findById(id) {
		return axios.get('/weddingDressHall/rent-package/' + id);
	}
}

